import { useEffect } from 'react';
import { Box, Text } from '@chakra-ui/react';

import Head from './components/head';
import Table from './components/table';
import { useFilters } from './hooks/state/useFilters';
import { useEditDetail } from './hooks/state/useEditDetail';
import { usePromotionClaim } from './hooks/state/usePromotionClaim';

export default function ConsumerPromotion() {
    const filters = useFilters();
    const stateEdit = useEditDetail();
    const statePromotion = usePromotionClaim();

    useEffect(() => {
        filters.reset();
        stateEdit.reset();
        statePromotion.reset();
    }, []);

    return (
        <Box p={'20px'} bg={'semantic.100'} borderRadius={'8px'} boxShadow={'0px 1px 3px 0px #0D0A2C1A'}>
            <Text fontWeight={'600'} fontSize={'sm'} mb={'24px'}>
                Consumer Promotion
            </Text>

            <Head />
            <Table />
        </Box>
    );
}
